import { render, staticRenderFns } from "./JiraVelocity.vue?vue&type=template&id=5bf30a0e&scoped=true"
import script from "./JiraVelocity.vue?vue&type=script&lang=js"
export * from "./JiraVelocity.vue?vue&type=script&lang=js"
import style0 from "./JiraVelocity.vue?vue&type=style&index=0&id=5bf30a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf30a0e",
  null
  
)

export default component.exports